export default __webpack_public_path__ + "static/media/document-logo-1.056af73f.svg";